import React, {Fragment, useMemo} from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import LoaderCsvForm from './csv-form';
import LoaderXmlForm from './xml-form';
import {Button, Divider, Radio } from 'antd';
import {connect} from 'react-redux';
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";
import {hideLoaderCCs, setLoaderCC, setLoaderFormat} from "./actions";
import {MODAL_WIDTH_LG} from "../../../styles/constants";
import EnhancedModal from "../../../components/enhanced-modal";
import ArtefactList from "../../../components/artefact-list";
import LoaderPluginForm from './plugin-form'


const mapStateToProps = state => ({
  format: state.scenes.dataManager.loader.shared.format,
  ccs: state.scenes.dataManager.loader.shared.ccs,
  permissions: state.app.user.permissions,
});

const mapDispatchToProps = dispatch => ({
  setFormat: format => dispatch(setLoaderFormat(format)),
  onCCsHide: format => dispatch(hideLoaderCCs(format)),
  onCCSet: ccTriplet => dispatch(setLoaderCC(ccTriplet)),
});

const Loader = ({
                  t,
                  format,
                  ccs,
                  setFormat,
                  onCCsHide,
                  onCCSet,
                  permissions
                }) => {
    const hasPermissionForPlugins = useMemo(() => permissions.functionality.includes("plugins"), [permissions])
    return (
        <Fragment>
            <Radio.Group
                defaultValue={format}
                onChange={({target}) => setFormat(target.value)}
            >
                <Radio.Button value="csv">
                    CSV
                </Radio.Button>
                <Radio.Button value="sdmx-ml">
                    SDMX-ML
                </Radio.Button>
                {hasPermissionForPlugins && <Radio.Button value="plugin">
                    {t('data.csv.otherFiles.label')}
                </Radio.Button>}
            </Radio.Group>

            <Divider/>
            {(format === 'csv' ) && (
                <LoaderCsvForm  />
            )}
            {format === 'sdmx-ml' && (
                <DataLanguageConsumer>
                    {dataLanguage => <LoaderXmlForm dataLanguage={dataLanguage}/>}
                </DataLanguageConsumer>
            )}
            { format === 'plugin'  && (
                <LoaderPluginForm />
            )}
            <EnhancedModal
                visible={ccs !== null}
                title={t('scenes.dataManager.loader.modals.ccs.title')}
                footer={<Button onClick={onCCsHide}>{t('commons.buttons.close.title')}</Button>}
                onCancel={onCCsHide}
                width={MODAL_WIDTH_LG}
            >
                <ArtefactList
                    artefacts={ccs}
                    onRowClick={({id, agencyID, version}) => onCCSet({id, agencyID, version})}
                />
            </EnhancedModal>
        </Fragment>
    )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(Loader);
